import React from "react";
import { ButtonToggle, ButtonToggleOption } from "@showitinc/showit-wc";

import AppConstants from "../../constants/AppConstants";
import ElementActions from "../elementproperties/ElementActions";
import SplitMergeWrapper from "../../app2components/base/SplitMergeWrapper";
import { TEXT_COLUMNS } from "../../constants/MergeConstants";

const { INPUT_SOURCE_PROPERTY_INPUT } = AppConstants;

const ColumnOptions = ({
  columns = 1,
  element,
  disabled,
  label = "Columns",
  onPropChange,
  context,
  visiblePropMap,
  onlyShowDesktop = false,
}) => {
  const _updateColumnCount = (e) => {
    const { value: newValue } = e.detail;
    const updates = ElementActions.buildColumnUpdates(element, Number(newValue));

    updates.forEach((update, i) =>
      onPropChange({ ...update, addUndo: i === 0, source: INPUT_SOURCE_PROPERTY_INPUT })
    );
  };

  const checked = (value) => columns === value;

  return (
    <SplitMergeWrapper
      sync
      visible={!visiblePropMap || !!visiblePropMap?.[TEXT_COLUMNS]}
      onlyShowDesktop={onlyShowDesktop}
    >
      <ButtonToggle
        label={label}
        context={context}
        disabled={disabled}
        value={columns}
        onSIChange={_updateColumnCount}
      >
        <ButtonToggleOption
          size="sm"
          value="1"
          icon="column1x"
          checked={checked(1)}
          disabled={disabled}
        />
        <ButtonToggleOption
          size="sm"
          value="2"
          icon="column2x"
          checked={checked(2)}
          disabled={disabled}
        />
        <ButtonToggleOption
          size="sm"
          value="3"
          icon="column3x"
          checked={checked(3)}
          disabled={disabled}
        />
        <ButtonToggleOption
          size="sm"
          value="4"
          icon="column4x"
          checked={checked(4)}
          disabled={disabled}
        />
      </ButtonToggle>
    </SplitMergeWrapper>
  );
};

export default ColumnOptions;
